import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import { getBannerList,getHomeList,getQuickButtons,getLastUpdate,getLikeList } from '@/services/program';
import { Toast } from 'antd-mobile';
import wx from 'wx';
import styles from './styles.scss';
import SearchInput from '@/components/SearchInput';
import ButtonList from './components/ButtonList';
import Banner from './components/Banner';
import VerticalList from './components/VerticalList';
import HorizontalList from './components/HorizontalList';
import GridList from './components/GridList';
import { updateUserLocation } from '@/utils/wechat';


export default (props) => {
  const areaCode = props.location.query.adCode;

  const [bannerList, setBannerList] = useState([]);
  const [buttonList, setButtonList] = useState([]);
  const [homeList,setHomeList] = useState([]);
  const [newsList,setNewsList] = useState([]);
  const [likeList,setLikeList] = useState([]);

  useEffect(() => {

    let params = {};
    if (areaCode) {
      params.areaCode = areaCode;
    } else {
    }

    updateUserLocation({
      success: (code) => {
        history.push('/nav/program?adCode=' + code);
      }
    });

    getHomeList(params).then(res => {
      console.log(res);
      if (res && res.code == 200) {
        setHomeList(res.data);
      }else {
        Toast.fail('获取失败，请重试',1);
      }
    }).catch(e =>{
      Toast.fail('获取失败，请重试',1);
    });

    getBannerList().then(res => {
      console.log(res);
      if (res && res.code == 200) {
        setBannerList(res.data);
      }

    });

    getQuickButtons(params).then(res => {
      console.log(res);
      if (res && res.code == 200) {
        setButtonList(res.data);
      }

    });

    params.pageNo = 1;
    params.pageSize = 4;
    getLastUpdate(params).then(res => {
      if (res && res.code == 200) {
        setNewsList(res.data.list);
      }
    });

    getLikeList(params).then(res => {
      if (res && res.code == 200) {
        setLikeList(res.data.list);
      }
    });
  },[]);



  return (
    <div>
      <SearchInput placeholder={'请输入您想要查询的栏目'} disable onClick={()=> {
        history.push('/program/search');
      }}/>

      {homeList.map(item =>{
        if (item.type == 'banner') {
          return(<Banner bannerList={bannerList}/>)
        } else if (item.type == 'quick') {
          return ( <ButtonList buttonList={buttonList}/>)
        }else if (item.type == 'lastUpdate') {
          return (<HomeColumn showType={item.showType} title={item.name} dataList={newsList}
                              onMore={()=>{
                                history.push({pathname:'/program/videoList',state:{areaCode:areaCode,title:item.name,type:item.type}});
                              }}/>)
        }else if (item.type == 'like') {
          return (<HomeColumn showType={item.showType} title={item.name} dataList={likeList}
                              onMore={()=>{
                                history.push({pathname:'/program/videoList',state:{areaCode:areaCode,title:item.name,type:item.type}});
                              }}/>)
        }else {
          return (<HomeColumn showType={item.showType} title={item.name} dataList={item.columnVideoList}
                              onMore={()=>{
                                history.push({pathname:'/program/videoList',state:{programId:item.columnId,title:item.name,type:item.type}});
                              }}/>)
        }
      })}


      <div style={{height:'20px'}}/>
    </div>
  )
}



const HomeColumn = (props) => {
  const {showType, dataList,title,onMore} = props;
  //1横向 2纵向 3宫格
  if (showType == '1') {
    return (
      <HorizontalList  dataList={dataList} title={title} onMore={onMore}/>
  )
  }else if (showType == '2') {
    return(
      <VerticalList dataList={dataList} title={title} onMore={onMore}/>
    )
  } else if (showType == '3') {
    return(
      <GridList dataList={dataList} title={title} onMore={onMore}/>
    )
  } else {
    return null;
  }

}




